<template>
    <div>
      <div class="col-md-12 card text-left">
        <div class="card-header"></div>
        <div class="report-filters" style="align-items: end;">
          <div class="col-md-3 col-sm-6 col-xs-12 form-group pull-left">
            <label class="form-label">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control" v-model="filters.location" @change="onFilterChange">
              <option :value="''">{{$t('reports.allLocations')}}</option>
              <option v-for="(loc, index) in locations" :key="index" :label="loc.name" :value="loc.id">{{loc.name}}</option>
            </select>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12 form-group pull-left date-range">
            <label class="form-label">{{$t('reports.dateInterval')}}</label>
            <el-date-picker
              type="daterange"
              v-model="filters.dateRange"
              class="mid w-100"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :name="pickerNames"
              :picker-options="pickerOptions"
              :clearable="false"
              style="width: 100%;"
            >
            </el-date-picker>
          </div>
          <div class="col-md-2 col-sm-6 col-xs-12 form-group pull-left">
            <label class="form-label">{{$t('reports.orderId')}}</label>
            <input type="number" class="form-control" v-model="filters.orderId" :placeholder="$t('reports.orderId')" @keyup.enter="getData(null)">
          </div>
          <div class="search-button-reports form-group pull-left" style="margin-bottom: 34px;">
            <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="getData(null)"><i class="ti-search"></i></div>
          </div>
          <div class="search-button-reports form-group pull-left" style="margin-bottom: 34px;">
            <div :title="$t('reports.export')" class="btn btn-icon btn-info btn-print" @click="exportData()"><i class="ti-file"></i></div>
          </div>
        </div>
        <div class="card-content total-pagination pad-15">
          <data-tables-server
              class=""
              @query-change="paginationChanged"
              v-loading="loading"
              :data="responsesTableData"
              :search-def="{ show: false }"
              :total="totalResponses"
              :pagination-props="paginationProps"
              :table-props="tableOptions"
              style="width: 100%;"
            >
            <el-table-column
              :min-width="60"
              prop="id"
              label="Id"
            ></el-table-column>
            <el-table-column :min-width="150" :label="$t('reports.dateTime')">
              <template slot-scope="props">
                <span>{{ props.row.answered_at }}</span>
              </template>
            </el-table-column>
            <el-table-column :min-width="120" :label="$t('reports.reorderResponse')">
              <template slot-scope="props">
                <span>{{ responseLabel(props.row.response) }}</span>
              </template>
            </el-table-column>
            <el-table-column :min-width="120" :label="$t('reports.orderId')">
              <template slot-scope="props">
                <span>{{ props.row.order_id || props.row.order_token || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column :min-width="140" :label="$t('dashboard.selectLocation')">
              <template slot-scope="props">
                <span>{{ props.row.location_name || '-' }}</span>
              </template>
            </el-table-column>
          </data-tables-server>
        </div>
      </div>
    </div>
</template>
<script>
  import {DatePicker} from 'element-ui'
  import moment from 'moment'

  export default {
    components: {
      [DatePicker.name]: DatePicker
    },
    created () {
      this.verifyUserLocations()
      this.getData(null)
    },
    data () {
      return {
        loading: false,
        filters: {
          location: '',
          orderId: '',
          // Responses are kept only 10 days, so the filter is limited to that window.
          dateRange: [
            moment().subtract(10, 'days').format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
          ]
        },
        locations: [],
        paginationProps: {
          layout: 'prev, pager, next, sizes, total'
        },
        tableOptions: {},
        pickerNames: ['date_from', 'date_to'],
        pickerOptions: {
          disabledDate (date) {
            // Only allow the last 10 days (data retention window), up to today.
            const minDate = moment().subtract(10, 'days').startOf('day')
            const maxDate = moment().endOf('day')
            return moment(date).isBefore(minDate) || moment(date).isAfter(maxDate)
          }
        },
        totalResponses: null,
        responsesTableData: []
      }
    },
    methods: {
      responseLabel (response) {
        if (response === 'YES') return this.$t('reports.reorderResponseYes')
        if (response === 'NO') return this.$t('reports.reorderResponseNo')
        return response
      },
      verifyUserLocations () {
        this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
          id: location.true_id,
          name: location.name
        }))

        if (!this.isOwner()) {
          let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))
          if (allowedLocations.length > 0) {
            this.locations = this.locations.filter(function (el) {
              return allowedLocations.includes(el.id)
            })
          }
        }
      },
      onFilterChange () {
        this.getData(null)
      },
      paginationChanged (query) {
        if (query.type === 'page') this.getData(query)
        if (query.type === 'size') this.getData(query)
      },
      buildParams () {
        return {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_id: this.filters.location || null,
          order_id: this.filters.orderId || null,
          from_date: this.filters.dateRange ? this.filters.dateRange[0] : null,
          to_date: this.filters.dateRange ? this.filters.dateRange[1] : null
        }
      },
      getData (query) {
        const data = this.buildParams()

        this.loading = true
        const pageSize = query ? query.pageSize : 20
        const page = query ? query.page : 1
        this.apiRequest('/reports/reorder-popup-responses?page=' + page + '&pageSize=' + pageSize, 'GET', data, response => {
          if (response.status === true) {
            this.responsesTableData = response.data.data
            this.totalResponses = response.data.total
          }
          this.$nextTick(function () {
            this.loading = false
          })
        })
      },
      exportData () {
        const data = this.buildParams()

        this.loading = true
        this.apiRequest('/reports/reorder-popup-responses-export', 'GET', data, response => {
          if (response.status === true) {
            const link = document.createElement('a')
            link.href = response.data.file
            link.setAttribute('download', response.data.file_name)
            document.body.appendChild(link)
            link.click()
          }
          this.loading = false
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/ReorderPopupResponses.vue